import { Route, Switch, Redirect, useHistory } from 'react-router-dom';

import { useAuth } from 'modules/auth/hooks/useAuth';
import { Loader } from 'modules/ui/loader';
import { MainLayout } from 'modules/layouts';

import { DashboardPage } from './Dashboard';
import { ProfilePage } from './Profile';
import { TechnicianPage } from './Technician';
import { FinancialPage } from './Financial';
import { CustomerPage } from './Customer';
import { TransactionPage } from './Transaction';
import { UnassignedCallsPage } from './UnassignedCalls';

import { useEffect } from 'react';
import { onFirebaseMessageListener, requestFirebaseNotificationPermission } from 'modules/firebase/firebase';
import { registerPushToken } from 'modules/firebase/hooks/crud';
import { getDeviceType } from 'modules/firebase/utils';
import { DailyTrackingPage } from './DailyTracking';
import { UsersListPage } from './UsersList';

export const Private = () => {
  const history = useHistory();

  const { user, isUserEmptyProfile, isCompanyAdmin, isSuperAdmin } = useAuth();

  useEffect(() => {
    if (!user) return; 

    requestFirebaseNotificationPermission().then(token => {
      if (token) {
        const type = getDeviceType();
        console.log('Token received', token, 'Device:', type, isCompanyAdmin, isSuperAdmin);
        if (!isCompanyAdmin && !isSuperAdmin) {
          registerPushToken(token, type).catch(console.error);
        } else {
          console.log('Token sends only for technicians');
        }
      }
    });

    onFirebaseMessageListener().then(payload => {
      console.log('Received in foreground:', payload);
      history.push('/unassigned-calls');
    });
  }, [user, isCompanyAdmin, isSuperAdmin]);

  return user ? (
    <MainLayout>
      {isSuperAdmin ? (
        <Switch>
          <Route exact path="/customer" component={CustomerPage} />
          <Route exact path="/transaction" component={TransactionPage} />
          <Route exact path="/financial" component={FinancialPage} />
          <Route exact path="/daily-tracking" component={DailyTrackingPage} />
          <Route exact path="/users-list" component={UsersListPage} />
          <Route exact path="/my-profile" component={ProfilePage} />
          <Redirect to={isUserEmptyProfile ? '/my-profile' : '/customer'} />
        </Switch>
      ) : isCompanyAdmin ? (
        <Switch>
          <Route exact path="/dashboard" component={DashboardPage} />
          <Route exact path="/technician" component={TechnicianPage} />
          <Route exact path="/financial" component={FinancialPage} />
          <Route exact path="/unassigned-calls" component={UnassignedCallsPage} />
          <Route exact path="/my-profile" component={ProfilePage} />
          <Redirect to={isUserEmptyProfile ? '/my-profile' : '/dashboard'} />
        </Switch>
      ) : (
        <Switch>
          <Route exact path="/dashboard" component={DashboardPage} />
          <Route exact path="/unassigned-calls" component={UnassignedCallsPage} />
          
          <Route exact path="/my-profile" component={ProfilePage} />
          <Redirect to={isUserEmptyProfile ? '/my-profile' : '/dashboard'} />
        </Switch>
      )}
    </MainLayout>
  ) : (
    <Loader isLoading />
  );
};
